module.exports = __webpack_public_path__ + "media/fonts/ProximaNova-RegularIt-35799a99.svg";